import { customerApi } from './api';

export const teacherQueryService = {
  submitQuery: async (data) => {
    const response = await customerApi.post('/teacher-queries', data);
    return response.data;
  },

  getQueries: async (params = {}) => {
    const response = await customerApi.get('/teacher-queries', { params });
    return response.data;
  },

  getQuery: async (id) => {
    const response = await customerApi.get(`/teacher-queries/${id}`);
    return response.data;
  },

  getStatistics: async () => {
    const response = await customerApi.get('/teacher-queries/statistics');
    return response.data;
  },
};
